import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { RiDashboard3Line, RiMenuLine, RiCloseLine } from "react-icons/ri";
import { VscGraphScatter } from "react-icons/vsc";
import { TbUsers, TbUser, TbNotebook, TbChartBar } from "react-icons/tb";
import { BiLogOut } from 'react-icons/bi';
import { handleSignOut } from '../../utils/auth';
import { SlOrganization } from "react-icons/sl";
import { useApp } from '../../context/AppContext';

const SidebarItem = ({ icon, label, to, isActive, onClick }) => (
    <Link
        to={to}
        onClick={onClick}
        className={`flex items-center space-x-3 px-6 py-3 rounded-lg transition-colors ${isActive ? 'bg-inputBackground text-darkGreen' : 'hover:bg-inputBackground hover:bg-opacity-5 text-white'
            }`}
    >
        {icon}
        <span className={`text-sm font-medium ${isActive ? 'text-darkGreen' : 'text-white'}`}>
            {label}
        </span>
    </Link>
);

const Sidebar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { user } = useApp();
    const isSuperAdmin = user?.role === 'super_admin';

    const admin = [
        {
            icon: <TbChartBar size={24} />,
            label: 'Social Impact Dashboard',
            to: '/'
        },
        {
            icon: <VscGraphScatter size={24} />,
            label: 'ESG Dashboard',
            to: '/esg-details'
        },
        {
            icon: <RiDashboard3Line size={24} />,
            label: 'Summary',
            to: '/summary'
        },
        ...(isSuperAdmin ? [
            {
                icon: <SlOrganization size={24} />,
                label: 'Organizations',
                to: '/organizations'
            },
        ] : []),
        {
            icon: <TbUsers size={24} />,
            label: 'Farmers',
            to: '/farmers'
        },
    ]

    const farmer = [
        {
            icon: <RiDashboard3Line size={24} />,
            label: 'Dashboard',
            to: '/farmer-dashboard'
        },
        {
            icon: <TbNotebook size={24} />,
            label: 'Questionnaire',
            to: '/questionnaire'
        },
        {
            icon: <TbUser size={24} />,
            label: 'About Me',
            to: '/about-farmer'
        }
    ]

    const menuItems = [
        ...(user?.org ? admin : farmer)
    ];

    return (
        <>
            {/* Mobile Menu Button */}
            <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className={`lg:hidden fixed left-4 z-[60] p-2 rounded-lg bg-darkGreen text-white hover:bg-opacity-90 ${isMobileMenuOpen ? 'top-10' : 'top-2'}`}
            >
                {isMobileMenuOpen ? <RiCloseLine size={24} /> : <RiMenuLine size={24} />}
            </button>

            {/* Overlay for mobile */}
            {isMobileMenuOpen && (
                <div
                    className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-[45]"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            {/* Sidebar Container */}
            <aside
                className={`
                    fixed top-0 left-0 h-full w-[272px] 
                    lg:translate-x-0 transition-transform duration-300 ease-in-out
                    z-[50] py-3 bg-transparent
                    ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
                `}
            >
                <div className="bg-darkGreen h-full mx-3 flex flex-col" style={{ borderRadius: '30px' }}>
                    <div className="p-6 pt-8">
                        <h1 className={`text-white text-2xl font-bold ${isMobileMenuOpen ? 'text-center' : ''}`}>
                            SHARE FARM
                        </h1>
                        <p className='text-white text-sm opacity-50 text-wrap break-words'>{user?.email}</p>
                    </div>

                    <nav className="flex-1 px-3 py-4 space-y-1">
                        {menuItems.map((item, index) => (
                            <SidebarItem
                                key={index}
                                {...item}
                                isActive={location.pathname === item.to}
                                onClick={() => setIsMobileMenuOpen(false)}
                            />
                        ))}
                    </nav>

                    <div className="px-3 mb-4">
                        <button
                            onClick={() => handleSignOut(navigate)}
                            className="flex items-center space-x-3 w-full px-6 py-3 rounded-lg text-white hover:bg-inputBackground hover:bg-opacity-5 transition-colors"
                        >
                            <BiLogOut size={24} />
                            <span className="text-sm font-medium">Sign Out</span>
                        </button>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;